import { AspSyncRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useTriggerAspSync() {
  const [syncing, setSyncing] = useState(false);

  async function triggerAspSync(params: AspSyncRequest) {
    try {
      setSyncing(true);
      const res = await api.triggerAspSync(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setSyncing(false);
    }
  }

  return { syncing, triggerAspSync };
}
